module.exports = __webpack_public_path__ + "img/germany-filled-with-pellets.362ebcf.png";